import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { db } from "../../../firebase";

export default function ExportCSVSeason(props) {
    let { id } = useParams()
    let seasonID = id

    function flatten(object, addToList = [], prefix = '') {
        // https://stackoverflow.com/questions/50009159/json-to-csv-flattening-nested-json

        Object.keys(object).map(key => {
            if (object[key] === null) {
                addToList[prefix + key] = "";
            } else
                if (object[key] instanceof Array) {
                    // addToList[prefix + key] = listToFlatString(object[key]);
                    for (const i in object[key]) {
                        flatten(object[key][i], addToList, prefix + key + "." + i)
                    }
                } else if (typeof object[key] == 'object' && !object[key].toLocaleDateString) {
                    flatten(object[key], addToList, prefix + key + '.');
                } else {
                    addToList[prefix + key] = object[key];
                }
        });
        return addToList;
    }



    function convertToCSV(arr) {
        let array = []
        for (const day of arr) {
            const date = day.date
            const dayName = day.name
            if (!'dayMatches' in day) {
                console.log('dateMatches not in day', arr)
                continue
            }

            // dayMatches: list()
            const dayMatches = day.dayMatches
            for (const match of dayMatches) {
                const matchName = match.name
                const players = match.thisPlayers
                const results = match.results
                const obj = {
                    date,
                    dayName,
                    matchName,
                    players,
                    results,
                }
                array.push(obj)
            }

        }

        return array

        // console.log(array)

        // // const array = [Object.keys(arr[0])].concat(arr)

        // const csvContent = "data:text/csv;charset=utf-8," + array.map(it => {
        //     return Object.values(it).toString()
        // }).join('\n')
        // return csvContent
    }


    async function getDays() {
        let days = []
        console.log(seasonID)
        const seasonDBRef = db.collection("seasons").doc(seasonID)
        await seasonDBRef.collection("days")
            .get()
            .then(async (querySnapShot) => {
                let day_objs = [] // day objects

                querySnapShot.forEach(async (doc) => {
                    const dayID = doc.id
                    let dayObj = doc.data()
                    dayObj.dayID = dayID

                    day_objs.push(dayObj)
                })

                for (const dayObj of day_objs) {
                    const dayMatches = await getMatches(dayObj.dayID)
                    dayObj.dayMatches = dayMatches
                    days.push(dayObj)
                }
            })

        // export to csv 
        let rows = days
        console.log(rows)

        const csvContent_json = convertToCSV(rows)
        var data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(csvContent_json));

        var a = document.createElement('a');
        a.href = 'data:' + data;
        a.download = 'data.json';
        a.innerHTML = 'download JSON';

        a.click()



        // const csvContent = convertToCSV(rows)

        // console.log(csvContent)
        // var encodedUri = encodeURI(csvContent);
        // window.open(encodedUri);
    }

    async function getMatches(dayID) {
        const matches = []
        const dayDBRef = db.collection("seasons").doc(seasonID).collection("days").doc(dayID)
        await dayDBRef.collection("matches")
            .get()
            .then((querySnapShot) => {
                querySnapShot.forEach((doc) => {
                    const matchID = doc.id
                    let matchObj = doc.data()
                    matchObj.matchID = matchID

                    matches.push(matchObj)
                })
            })
        // console.log(matches)
        return matches
    }

    return (
        <div>
            <div>Export CSV Season</div>
            <Button onClick={getDays}>Export this Season as CSV</Button>
        </div>
    )
}